import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


const config = {
  apiKey: 'AIzaSyDoDVQrsyDj2yJ-Pc0TEmCGN_RXp6Rayu0',
  authDomain: 'wedding-212919.firebaseapp.com',
  databaseURL: 'https://wedding-212919.firebaseio.com',
  projectId: 'wedding-212919',
};
firebase.initializeApp(config);
export const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);
export const currentUser = firebase.auth() && firebase.auth().currentUser;

export function facebooklogin() {
  const provider = new firebase.auth.FacebookAuthProvider();
  provider.addScope('email');
  return firebase.auth().signInWithPopup(provider);
}
export function googlelogin() {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope('email');
  return firebase.auth().signInWithPopup(provider);
}

export function onAuthStateChanged(done = () => {}) {
  return firebase.auth().onAuthStateChanged(done);
}


export default firebase;
